var _rect, _g, _g2, _rect2, _rect3, _path, _g3, _path2, _g4, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _circle, _circle2, _circle3, _rect17, _rect18, _rect19, _g5, _g6, _g7, _g8, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingTimeline1Image(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 440,
    viewBox: "0 0 440 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 440,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.5 218.506C289.164 218.506 372.39 204.177 372.39 186.5C372.39 168.823 289.164 154.494 186.5 154.494C83.8356 154.494 0.609619 168.823 0.609619 186.5C0.609619 204.177 83.8356 218.506 186.5 218.506Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.645 336.599C293.645 346.226 245.661 354.05 186.5 354.05C127.339 354.05 79.3552 346.226 79.3552 336.599C79.3552 326.972 127.314 319.174 186.5 319.174C245.686 319.174 293.645 326.972 293.645 336.599Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5 299.538C276.763 299.538 349.935 287.631 349.935 272.942C349.935 258.254 276.763 246.347 186.5 246.347C96.2371 246.347 23.0647 258.254 23.0647 272.942C23.0647 287.631 96.2371 299.538 186.5 299.538Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5 53.801C245.674 53.801 293.645 45.9993 293.645 36.3754C293.645 26.7515 245.674 18.9497 186.5 18.9497C127.326 18.9497 79.3552 26.7515 79.3552 36.3754C79.3552 45.9993 127.326 53.801 186.5 53.801Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5 126.653C276.763 126.653 349.935 114.746 349.935 100.058C349.935 85.3693 276.763 73.462 186.5 73.462C96.2371 73.462 23.0647 85.3693 23.0647 100.058C23.0647 114.746 96.2371 126.653 186.5 126.653Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.5 285.506C356.164 285.506 439.39 271.177 439.39 253.5C439.39 235.823 356.164 221.494 253.5 221.494C150.836 221.494 67.6096 235.823 67.6096 253.5C67.6096 271.177 150.836 285.506 253.5 285.506Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.645 403.599C360.645 413.226 312.661 421.05 253.5 421.05C194.339 421.05 146.355 413.226 146.355 403.599C146.355 393.972 194.314 386.174 253.5 386.174C312.686 386.174 360.645 393.972 360.645 403.599Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.5 366.538C343.763 366.538 416.935 354.631 416.935 339.942C416.935 325.254 343.763 313.347 253.5 313.347C163.237 313.347 90.0647 325.254 90.0647 339.942C90.0647 354.631 163.237 366.538 253.5 366.538Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.5 120.801C312.674 120.801 360.645 112.999 360.645 103.375C360.645 93.7515 312.674 85.9497 253.5 85.9497C194.326 85.9497 146.355 93.7515 146.355 103.375C146.355 112.999 194.326 120.801 253.5 120.801Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.5 193.653C343.763 193.653 416.935 181.746 416.935 167.058C416.935 152.369 343.763 140.462 253.5 140.462C163.237 140.462 90.0647 152.369 90.0647 167.058C90.0647 181.746 163.237 193.653 253.5 193.653Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.8167,
    y: 100.504,
    width: 329.913,
    height: 272.996,
    rx: 4.5,
    fill: "white",
    stroke: "#252525"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 302.5,
    width: 285,
    height: 47,
    rx: 4.5,
    fill: "#252525",
    stroke: "#252525"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_231_211",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 308,
    width: 28,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.805 319.984C232.166 319.98 232.494 320.184 232.645 320.503C232.808 320.847 232.757 321.225 232.549 321.482L216.563 341.231C216.453 341.346 216.357 341.422 216.222 341.484C215.952 341.608 215.658 341.613 215.395 341.476C215.013 341.296 214.772 340.857 214.892 340.415L217.769 329.545L205.931 329.581C205.57 329.585 205.242 329.38 205.092 329.062C204.941 328.744 204.979 328.339 205.187 328.083L221.185 308.361C221.449 308.014 221.92 307.895 222.314 308.102C222.723 308.269 222.937 308.72 222.844 309.149L219.967 320.019L231.805 319.984Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_231_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.813 319.884C232.171 319.881 232.496 320.084 232.646 320.399C232.808 320.741 232.757 321.116 232.551 321.37L216.697 340.956C216.588 341.07 216.493 341.145 216.359 341.207C216.091 341.33 215.8 341.335 215.539 341.199C215.16 341.02 214.921 340.586 215.04 340.147L217.893 329.367L206.153 329.403C205.795 329.407 205.47 329.203 205.321 328.888C205.171 328.573 205.209 328.171 205.415 327.917L221.281 308.358C221.543 308.014 222.009 307.896 222.4 308.101C222.806 308.267 223.018 308.714 222.926 309.14L220.073 319.92L231.813 319.884Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_231_211",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 308,
    width: 31,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M231.849 320.365C232.209 320.361 235.039 321.86 235.19 322.178C235.353 322.522 235.302 322.9 235.095 323.157L219.109 342.906C218.998 343.021 218.903 343.096 218.768 343.159C218.497 343.283 218.203 343.288 217.94 343.15C217.559 342.97 215.197 341.067 215.316 340.625L220.465 332.379H209.252C208.891 332.383 205.312 328.984 205.52 328.728C213.013 319.266 218.362 312.559 221.568 308.607C222.092 307.961 224.465 309.57 224.859 309.777C225.268 309.944 225.482 310.395 225.389 310.824L222.512 321.694L231.849 320.365Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_231_211)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78.3186,
    y: 124.654,
    width: 284.909,
    height: 51.946,
    rx: 4.5,
    fill: "#252525",
    stroke: "#252525"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0264,
    y: 141.361,
    width: 18.5311,
    height: 18.5311,
    rx: 2,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 129.941,
    y: 133.919,
    width: 33.4149,
    height: 33.4149,
    rx: 16.7075,
    stroke: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 182.387,
    y: 147.979,
    width: 37.0622,
    height: 5.29461,
    rx: 1,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 237.981,
    y: 147.979,
    width: 26.473,
    height: 5.29461,
    rx: 1,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 282.985,
    y: 147.979,
    width: 26.473,
    height: 5.29461,
    rx: 1,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 78.3186,
    y: 187.542,
    width: 284.909,
    height: 51.946,
    rx: 4.5,
    fill: "#252525",
    stroke: "#252525"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0264,
    y: 204.249,
    width: 18.5311,
    height: 18.5311,
    rx: 2,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 129.941,
    y: 196.807,
    width: 33.4149,
    height: 33.4149,
    rx: 16.7075,
    stroke: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 182.387,
    y: 210.867,
    width: 37.0622,
    height: 5.29461,
    rx: 1,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 237.981,
    y: 210.867,
    width: 26.473,
    height: 5.29461,
    rx: 1,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 282.985,
    y: 210.867,
    width: 26.473,
    height: 5.29461,
    rx: 1,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 329.913,
    height: 38.7095,
    rx: 4.5,
    transform: "matrix(1 0 0 -1 55.3167 93.7095)",
    fill: "#252525",
    stroke: "#252525"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.495,
    cy: 74.8548,
    r: 5.29461,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.0263,
    cy: 74.8548,
    r: 5.29461,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.557,
    cy: 74.8548,
    r: 5.29461,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 124.7,
    y: 264.875,
    width: 192.75,
    height: 3,
    fill: "#252525"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 178.004,
    y: 271.625,
    width: 85.6667,
    height: 3,
    fill: "#252525"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 178.004,
    y: 278.375,
    width: 85.6667,
    height: 3,
    fill: "#252525"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280 394.5H305",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.5 407V382",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.5 387.804C292.137 389.379 291.361 390.828 290.252 392.004C289.143 393.179 287.742 394.038 286.191 394.492C286.191 394.492 291.711 396.606 292.539 401.669C292.539 401.669 293.841 394.492 299.834 394.492C299.795 394.492 294.361 394.91 292.5 387.804Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_231_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0898 246.694H75.6361",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.863 254.467V238.921",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.863 242.53C67.6371 243.509 67.1546 244.411 66.4651 245.142C65.7756 245.872 64.904 246.407 63.9397 246.689C63.9397 246.689 67.3726 248.003 67.8876 251.152C67.8876 251.152 68.6967 246.689 72.4239 246.689C72.3994 246.689 69.0204 246.949 67.863 242.53Z",
    fill: "#252525"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_231_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.91 303.995H379.456",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.683 311.768V296.222",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.683 299.832C371.457 300.811 370.975 301.712 370.285 302.443C369.596 303.174 368.724 303.708 367.76 303.99C367.76 303.99 371.193 305.305 371.708 308.453C371.708 308.453 372.517 303.99 376.244 303.99C376.22 303.99 372.841 304.25 371.683 299.832Z",
    fill: "#252525"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_231_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.815 79.5809H166.361",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.588 87.354V71.8077",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.588 75.4172C158.362 76.3963 157.88 77.2975 157.19 78.0284C156.501 78.7593 155.629 79.2934 154.665 79.5759C154.665 79.5759 158.098 80.8903 158.613 84.0387C158.613 84.0387 159.422 79.5759 163.149 79.5759C163.124 79.5759 159.746 79.8359 158.588 75.4172Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M398.444 96.2375H413.991",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M406.218 104.011V88.4644",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M406.218 92.0739C405.992 93.053 405.509 93.9542 404.82 94.6851C404.13 95.416 403.258 95.9501 402.294 96.2326C402.294 96.2326 405.727 97.5469 406.242 100.695C406.242 100.695 407.051 96.2326 410.778 96.2326C410.754 96.2326 407.375 96.4925 406.218 92.0739Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M309.22 335.367H324",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M316.61 342.757V327.976",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M316.61 331.408C316.395 332.339 315.936 333.196 315.281 333.891C314.625 334.585 313.797 335.093 312.88 335.362C312.88 335.362 316.144 336.611 316.633 339.605C316.633 339.605 317.403 335.362 320.946 335.362C320.923 335.362 317.71 335.609 316.61 331.408Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M360.767 385.067L338.711 382.717C337.964 382.615 337.203 382.819 336.607 383.281L318.689 396.341C318.688 396.342 318.687 396.343 318.685 396.344C318.25 396.653 317.721 396.611 317.224 396.168C316.715 395.714 316.373 394.916 316.543 394.036L316.543 394.036L316.545 394.026L325.817 343.076L325.819 343.066L325.82 343.056C325.93 342.379 326.31 342.053 326.651 341.958C326.985 341.865 327.484 341.937 327.955 342.498L327.959 342.502L361.449 381.979C362.027 382.7 362.121 383.592 361.905 384.244C361.707 384.842 361.329 385.104 360.885 385.08L360.767 385.067Z",
    fill: "#252525",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(280 382)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_231_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5462,
    height: 15.5462,
    fill: "white",
    transform: "translate(60.0898 238.921)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_231_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5462,
    height: 15.5462,
    fill: "white",
    transform: "translate(363.91 296.222)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_231_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5462,
    height: 15.5462,
    fill: "white",
    transform: "translate(150.815 71.8077)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingTimeline1Image);
export default __webpack_public_path__ + "static/media/landing-timeline-1-image.de2ab25f3b524ed0bf28327a28fdb4f4.svg";
export { ForwardRef as ReactComponent };